/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractResourceService } from '@irian-ro/abstract-resource';
import { EnvironmentService } from '@irian-ro/util-environment';
import { FilterVO, UserPreferencesColumnModel, UserPreferencesModel } from '@well/domain';
import { Observable, ReplaySubject } from 'rxjs';
import { catchError, debounceTime, switchMap, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserPreferencesService extends AbstractResourceService<UserPreferencesColumnModel[], any, any, any> {
  private newObs = new ReplaySubject<{ selectedPreferences: any, preferencesName: string, labelName: string , callback}>();

  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('preferencesUrl')
    );
    this.onUserPreferencesSave().subscribe();
  }

  getUserPreferences(preferencesName: string): Observable<UserPreferencesColumnModel[]> {
    return <Observable<UserPreferencesColumnModel[]>>this.httpClient?.get(`${this.url}/column/${preferencesName}`);
  }

  getFilterPreferences(uuid: string): Observable<any> {
    return this.httpClient?.get(`${this.url}/${uuid}`);
  }

  getAllFilterLabels(preferenceName: string): Observable<FilterVO[]> {
    return <Observable<FilterVO[]> >this.httpClient?.get(`${this.url}/filter/${preferenceName}`);
  }

  deleteFilter(uuid: string) {
    return this.httpClient?.delete(`${this.url}/delete/filter/${uuid}`);
  }
  saveUserPreferences(selectedPreferences: any, preferencesName: string, labelName: string, callback?) {
    this.newObs.next({selectedPreferences, preferencesName, labelName, callback});
  }

  onUserPreferencesSave() {
    return this.newObs.asObservable()
      .pipe(debounceTime(500))
      .pipe(
        switchMap((item) => {
          const selectedPreferencesAsString = JSON.stringify(item.selectedPreferences);
          const userPreferences =  new UserPreferencesModel(item.preferencesName, item.labelName, selectedPreferencesAsString);
          return this.httpClient?.post(
            `${this.url}/`,
            userPreferences,
            {headers: this.headers, observe: 'response'})
            .pipe(tap( res => {
              item.callback();
            }))
            .pipe(catchError(val => this.newObs.asObservable()));
        }));
  }
}

